import { render } from "./reportsUw.vue?vue&type=template&id=d79fb7a8&scoped=true"
import script from "./reportsUw.vue?vue&type=script&lang=js"
export * from "./reportsUw.vue?vue&type=script&lang=js"

import "./reportsUw.vue?vue&type=style&index=0&id=d79fb7a8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d79fb7a8"]])

export default __exports__